import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M23.297 11.953C23.297 5.723 18.23.656 12 .656S.703 5.723.703 11.953c0 2.03.54 4.008 1.566 5.742L.745 23.208l5.513-1.524A11.26 11.26 0 0 0 12 23.25c6.23 0 11.297-5.067 11.297-11.297m-13.031-2.63H8.53A3.473 3.473 0 0 1 12 5.855a3.473 3.473 0 0 1 3.469 3.468 3.48 3.48 0 0 1-1.13 2.56l-1.472 1.35v1.35h-1.734v-2.114l2.034-1.866a1.736 1.736 0 0 0-1.172-3.014c-.956 0-1.73.778-1.73 1.734m.867 6.994h1.734v1.735h-1.734z" }, null, -1)
  ])))
}
export default { render: render }